import React, { useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

// Shown on a first login, gated on staff.setup_completed === false. Blocks the
// portal until they click "Get started" (persists setup_completed=true via
// /auth/complete-setup, so it shows once). A clean welcome + quick tour (no video).
export default function NewHireWalkthrough({ user, onDone }) {
  const [finishing, setFinishing] = useState(false);
  const firstName = (user && user.first_name) || 'there';

  const finish = async () => {
    setFinishing(true);
    try {
      await axios.post(API + '/auth/complete-setup', {}, {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      });
    } catch (e) {
      // Non-fatal: never trap the new hire out of the portal if the flag write fails.
      console.error('complete-setup failed:', e);
    }
    setFinishing(false);
    onDone();
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'var(--caam-cream, #FAF8F3)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', zIndex: 4000, overflowY: 'auto' }}>
      <div style={{ background: '#fff', borderRadius: '16px', boxShadow: '0 24px 64px rgba(0,0,0,0.12)', maxWidth: '720px', width: '100%', padding: '40px', boxSizing: 'border-box' }}>
        <div style={{ fontSize: '13px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--caam-accent, #BA7517)', marginBottom: '10px' }}>
          California African American Museum
        </div>
        <h1 style={{ fontSize: '28px', fontWeight: 700, color: 'var(--caam-text, #1f2937)', margin: '0 0 8px 0' }}>
          &#128075; Welcome, {firstName}!
        </h1>
        <p style={{ fontSize: '15px', color: 'var(--caam-text-muted, #5F5E5A)', lineHeight: 1.5, margin: '0 0 22px 0' }}>
          Welcome to the CAAM staff portal. Here&apos;s a quick tour of what you can do &mdash; everything lives in the menu on the left.
        </p>
        <div style={{ display: 'grid', gap: '14px', marginBottom: '30px' }}>
          {[
            ['🏠', 'Home', 'Your dashboard — announcements, upcoming events, and quick links.'],
            ['🧩', 'Apps', 'Chat with coworkers, and open Drive and Gmail right inside the portal.'],
            ['💼', 'My Workspace', 'See the equipment assigned to you and the forms you need.'],
            ['👥', 'Human Resources', 'Request time off, and browse the org chart and staff directory.'],
            ['🎧', 'Get Support', 'The orange button at the top-right reaches CAAM IT anytime.'],
          ].map(([icon, title, desc]) => (
            <div key={title} style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
              <div style={{ fontSize: '18px', width: '24px', textAlign: 'center', flexShrink: 0 }}>{icon}</div>
              <div>
                <div style={{ fontSize: '14.5px', fontWeight: 700, color: 'var(--caam-text, #1f2937)' }}>{title}</div>
                <div style={{ fontSize: '13px', color: 'var(--caam-text-muted, #5F5E5A)', lineHeight: 1.45 }}>{desc}</div>
              </div>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button onClick={finish} disabled={finishing}
            style={{ background: 'var(--caam-accent, #BA7517)', color: '#fff', border: 'none', borderRadius: '9px', padding: '12px 28px', fontSize: '15px', fontWeight: 600, cursor: finishing ? 'default' : 'pointer', opacity: finishing ? 0.6 : 1 }}>
            {finishing ? 'One moment…' : 'Get started →'}
          </button>
        </div>
      </div>
    </div>
  );
}
